import React from "react";
import classNames from "classnames";
import "./index.scss";

import CheckBox from "../CheckBox";
import { getTranslateTitle } from '../../../utils/objects-util.js';

const RadioButtons = ({
    items,
    value,
    onChange
}) => (
    <div className={classNames("radioButtons")}>
        {items && items.map(item=> (
            <div key={`radioButton-${item.value}`} className={classNames("radioButton", item.className)}>
                <label>
                    <input type="radio" value={item.value === (value && value.value)} checked={item.value === (value && value.value)} 
                        onChange={e=> onChange({ item, subItemIndex: null, value: true })}
                    />
                    {getTranslateTitle(item.title)}
                </label>
                {item.items && item.value === (value && value.value) && (!item.isShow || item.isShow()) && (
                    <div className={classNames("radioButtonSubitems")}>
                        {item.items.map((subItem, subItemIndex)=> (
                            <CheckBox key={`radioButtonSubitem-${subItem.title}`} 
                                label={getTranslateTitle(subItem.title)}
                                value={value && value.selected.indexOf(subItem.value) > -1}
                                onChange={val => onChange({ item, subItemIndex, value: val })}
                            />
                        ))}
                    </div>
                )}
            </div>
        ))}
    </div>
);

export default RadioButtons;